export default {
  addFromMenu: "أضف من القائمة",
  somethingWentWrong: "حدث خطأٌ ما!",
  emptyItems: "لم يتم إيجاد أي منتجات!",
  itemSearchTitle: "البحث",
  itemSearchPlaceholder: "ابحث عن منتج",
  itemCategoryTitle: "تصنيف المنتج",
  itemCategoryPlaceholder: "اختر من بين التصنيفات",
};
